import './pages/main/index.js';



// WEBPACK FOOTER //
// ./_src/script.js